module.exports = __webpack_public_path__ + "img/06.35c89b21.png";